import { useEffect, useState } from "react";
import { fileUrl } from "@/lib/api";

// Renders an image from the authed /api/files endpoint using a query-param token.
export default function AuthImg({ path, alt = "screenshot", className, onClick }) {
  const [src] = useState(() => fileUrl(path));
  if (!path) return null;
  return <img src={src} alt={alt} className={className} onClick={onClick} loading="lazy" />;
}
